import { Plugin } from '@nuxt/types'
import CalculatorModule from './api'

const accessor: Plugin = (_, inject) => {
  //* Инжектим глобально модуль калькулятора
  inject('calculator', CalculatorModule())
}

export default accessor
